import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "@firebase/firestore";
// Import the functions you need from the SDKs you need

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAp1a-6WCVqm7IQN3LroaAqsLdl3iQouXg",
  authDomain: "email-1389.firebaseapp.com",
  databaseURL: "https://email-1389-default-rtdb.firebaseio.com",
  projectId: "email-1389",
  storageBucket: "email-1389.appspot.com",
  messagingSenderId: "39772707497",
  appId: "1:39772707497:web:43ae865172bfc71e3e27b8",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const db = getFirestore(app);
